<div class="container">
  <mat-toolbar *ngIf="!inIframe && !examView && mobileView || (dataLoaded && (!user || (session && !session.role)))"
               color="accent" class="top-toolbar">
    <mat-toolbar-row class="toolbar-row">
      <app-button *ngIf="user && session && session.role && !examView"
                  class="menu-btn"
                  icon="menu"
                  (clicked)="sidenav.toggle()"></app-button>

      <div class="fill-space"></div>
      <app-logo [showText]="true"
                [autoClose]="mobileView"
                [redirectOnInteraction]="!examView"
                [sidenav]="sidenav"></app-logo>
      <div class="fill-space"></div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav #sidenav class="main-sidenav"
                 [fixedInViewport]="mobileView"
                 [mode]="mobileView ? 'over' : 'side'"
                 [opened]="!inIframe && !mobileView && !examView && user != null && session != null && session.role != null"
                 role="navigation">
      <mat-nav-list>
        <app-logo *ngIf="!mobileView" class="logo-sidenav"
                  [showText]="true" [vertical]="true" [autoClose]="mobileView"
                  [sidenav]="sidenav"></app-logo>

        <span class="profile-info center">
          <a *ngIf="user" [routerLink]="profileInfoUrl"
             matTooltip="Profile Information"
             i18n-matTooltip="Navigation|Profile Information title@@navigation-profile-information-title"
             matTooltipPosition="after">
            <avatar *ngIf="user"
                    [letters]="user.getAvatarLetters()"
                    [picture]="user.picture"></avatar>
          </a>
        </span>
        <div *ngIf="user" class="profile-name">{{user.firstName}} {{user.lastName}}</div>

        <div class="fill-space"></div>

        <span *ngIf="!dataLoaded" class="center">
          <mat-spinner color="primary" [diameter]="30"></mat-spinner>
        </span>

        <a mat-list-item *ngFor="let item of mailMenu" class="menu-item no-focus"
           [routerLink]="item.path"
           routerLinkActive="active"
           (click)="handleMenuItemSelection(sidenav)"
           [disabled]="!item.enabled"
           [matTooltip]="item.label" matTooltipPosition="after">
          <mat-icon *ngIf="item.icon" matLine [svgIcon]="item.icon" class="main-menu-item-icon"></mat-icon>
          <p class="badge-holder"
             [matBadge]="pendingTeacherRequests <= 9 ? pendingTeacherRequests : '9+'"
             [matBadgeOverlap]="true"
             matBadgeSize="small"
             matBadgePosition="above"
             [matBadgeHidden]="!pendingTeacherRequests || item.icon != 'teachers-icon'"></p>
          <p matLine class="main-menu-item-label center-align">{{item.label}}</p>
        </a>

        <div class="fill-space"></div>

        <a mat-list-item *ngFor="let item of supportMenu" class="menu-item"
           [routerLink]="item.path"
           routerLinkActive="active"
           (click)="handleMenuItemSelection(sidenav)"
           [disabled]="!item.enabled"
           [matTooltip]="item.label" matTooltipPosition="after">
          <mat-icon *ngIf="item.icon" matLine [svgIcon]="item.icon" class="main-menu-item-icon"></mat-icon>
          <p matLine class="main-menu-item-label center-align">{{item.label}}</p>
        </a>

        <language-switch class="center" [localeOverride]="true"></language-switch>

        <a mat-list-item *ngIf="user && session && session.role" class="menu-item no-focus" (click)="signOut(sidenav)"
           matTooltip="Sign out"
           i18n-matTooltip="Navigation|Sign out tooltip title@@navigation-sign-out-tooltip-title"
           matTooltipPosition="after">
          <mat-icon matLine svgIcon="sign-out-icon" class="main-menu-item-icon"></mat-icon>
          <p matLine class="main-menu-item-label center-align"
             i18n="Navigation|Sign out title@@navigation-sign-out-title">Sign out</p>
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content role="main" class="main-content" [class.mobile]="mobileView && !examView">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

